export enum ReservationStatus {
  Confirmed = 'http://schema.org/ReservationConfirmed',
  Hold = 'https://schema.org/ReservationHold',
  ReservationCancelled = 'https://schema.org/ReservationCancelled',
  Pending = 'https://schema.org/ReservationPending',
}
